<script>
import List from "./List";
import NewTransfer from "./NewTransfer/Index";

export default {
  components: {
    List,
    NewTransfer
  },

  data() {
    return {
      newTransferComponentKey: 0,
      transferHistoryComponentKey: 100,
      snackbarError: false,
      errorMessage: ""
    };
  },

  methods: {
    rerenderHistoryComponent() {
      this.transferHistoryComponentKey += 1;
    },
    rerenderNewTransferComponent() {
      this.newTransferComponentKey += 1;
    },
    forceRerenderTransferComponent() {
      this.rerenderHistoryComponent();
      this.rerenderNewTransferComponent();
    },
    setErrorMessage(val) {
      this.errorMessage = val;
      this.snackbarError = true;
    }
  }
};
</script>

<template>
  <div>
    <new-transfer
      :key="newTransferComponentKey"
      @refresh="forceRerenderTransferComponent()"
      @refreshOnError="rerenderHistoryComponent()"
      v-on:errorMessage="setErrorMessage"
    />

    <list channel-type="Wallet" :key="transferHistoryComponentKey" />

    <v-snackbar v-model="snackbarError" color="error">
      <span>{{ this.errorMessage }}</span>
      <v-btn text @click="snackbarError = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<style scoped>
.half {
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Transfers/Index.vue